import {
  DollarSign,
  Clock,
  AlertTriangle,
  Receipt,
} from 'lucide-react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { useInvoices } from '@/features/finance';
import { useMemo } from 'react';

const SPEND_CATEGORIES = [
  {
    category: 'Seafood',
    amount: 125000,
    pct: 35,
  },
  {
    category: 'Meat & Poultry',
    amount: 89000,
    pct: 25,
  },
  {
    category: 'Produce',
    amount: 71000,
    pct: 20,
  },
  {
    category: 'Dairy',
    amount: 43000,
    pct: 12,
  },
  {
    category: 'Dry Goods',
    amount: 28000,
    pct: 8,
  },
];

export function SpendView() {
  const { data: allData } = useInvoices();

  const stats = useMemo(() => {
    const invs = allData?.data ?? [];
    return {
      total: invs.length,
      disputed: invs.filter((i) => i.status === 'disputed').length,
      totalAmount: allData?.meta?.totalAmount ?? 0,
    };
  }, [allData]);

  return (
    <>
      <div className="grid gap-4 md:grid-cols-4">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Total Spend (MTD)
            </CardTitle>
            <DollarSign className="h-5 w-5 text-green-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600">
              ${stats.totalAmount.toLocaleString()}
            </div>
            <p className="text-xs text-muted-foreground">+12% vs last month</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Avg Invoice Value
            </CardTitle>
            <Receipt className="h-5 w-5 text-blue-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-blue-600">
              ${stats.total > 0 ? Math.round(stats.totalAmount / stats.total).toLocaleString() : 0}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Payment Cycle
            </CardTitle>
            <Clock className="h-5 w-5 text-amber-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-amber-600">28 days</div>
            <p className="text-xs text-muted-foreground">Avg days to payment</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">Dispute Rate</CardTitle>
            <AlertTriangle className="h-5 w-5 text-red-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-red-600">
              {stats.total > 0 ? ((stats.disputed / stats.total) * 100).toFixed(1) : 0}%
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Spend by Category</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {SPEND_CATEGORIES.map((item) => (
              <div key={item.category}>
                <div className="mb-1 flex justify-between">
                  <span>{item.category}</span>
                  <span className="text-muted-foreground">
                    ${item.amount.toLocaleString()} ({item.pct}%)
                  </span>
                </div>
                <div className="h-2 w-full rounded-full bg-muted">
                  <div
                    className="h-2 rounded-full bg-primary"
                    style={{ width: `${item.pct}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </>
  );
}
